import { useEffect, useRef, useState } from 'react';

const steps = [
  {
    num: '01',
    icon: 'ri-customer-service-2-line',
    title: '상담',
    desc: '전화 또는 카카오톡 상담으로 간단한 요청 사항을 알려주세요. 품목, 수량, 라벨 여부 등을 확인합니다.',
    color: '#0A508C',
  },
  {
    num: '02',
    icon: 'ri-palette-line',
    title: '디자인',
    desc: '브랜드 정보를 바탕으로 라벨 시안을 제작합니다. 수정 요청도 빠르게 반영됩니다.',
    color: '#3A7CC0',
  },
  {
    num: '03',
    icon: 'ri-tools-line',
    title: '제작·부착',
    desc: '팩과 라벨을 제작하고, 부착 서비스 신청 시 라벨 부착까지 완료합니다.',
    color: '#2BC0D0',
  },
  {
    num: '04',
    icon: 'ri-truck-line',
    title: '납품',
    desc: '완성된 제품을 신속하게 납품합니다.바로 출하 가능한 상태로 전달드립니다.',
    color: '#70C6A3',
  },
];

export default function ProcessSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="process" ref={ref} className="py-24" style={{ background: '#F5F8FB' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className={`text-center mb-14 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <div className="text-sm font-bold uppercase tracking-widest mb-3" style={{ color: '#2BC0D0' }}>HOW IT WORKS</div>
          <h2 className="text-4xl font-black text-gray-900 mb-3">간단한 4단계 프로세스</h2>
          <p className="text-gray-500 text-base">처음 이용하시는 분도 쉽고 빠르게 진행됩니다</p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative">
          {/* Connector Lines - Desktop Only */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-px" style={{ background: 'linear-gradient(to right, #0A508C, #3A7CC0, #2BC0D0, #70C6A3)', margin: '0 12.5%', zIndex: 0 }} />

          {steps.map((step, i) => (
            <div
              key={step.num}
              className={`relative flex flex-col items-center text-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 150}ms`, zIndex: 1 }}
            >
              {/* Circle */}
              <div
                className="w-24 h-24 rounded-full flex flex-col items-center justify-center mb-5 relative"
                style={{ background: step.color }}
              >
                <i className={`${step.icon} text-white text-2xl`} />
                <span className="text-white/60 text-xs font-bold mt-0.5">{step.num}</span>
              </div>

              {/* Content */}
              <h3 className="text-xl font-black text-gray-900 mb-2">{step.title}</h3>
              <p className="text-base text-gray-500 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className={`mt-12 flex flex-col md:flex-row items-center justify-center gap-3 transition-all duration-700 delay-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="flex items-center gap-2 text-base text-gray-500">
            <i className="ri-information-line" style={{ color: '#2BC0D0' }} />
            최초 주문 시 상담이 필요하지만, 재주문은 더욱 간편하게 진행됩니다.
          </div>
        </div>
      </div>
    </section>
  );
}
